<template>
    <div class="tuike">
        <header1></header1>
        <div class="main-tuike">
            <div class="nav-bg">
                <div class="nav-banner">
                    <div class="banner-box">
                        <div class="left">
                            <div class="title">契合科技营销活动平台</div>
                            <div class="title">海量模板，营销活动一站搭建</div>
                            <p class="sub-title">
                                契合科技营销活动平台，全方位支撑客户养成之旅的活动体系，
                                拉新、促活、留存、转化，标准化海量活动模版快速搭建，定制化业务指标对接，促留存、提转化，一站搞定。
                            </p>
                            <div>
                                <a @click="denglu" class="btn">立即试用</a>
                            </div>
                        </div>
                        <div class="nav-bars">
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/icon_1.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">活动模板多</div>
                                    <div class="subtxt">
                                        标准化活动模板100+，玩法类型丰富
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/icon_2.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">创建活动快</div>
                                    <div class="subtxt">
                                        6步创建活动，30分钟即可配置完成
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/icon_3.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">支持活动定制</div>
                                    <div class="subtxt">
                                        打通银行指标接口，快速响应业务需求
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/icon_4.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">风险控制</div>
                                    <div class="subtxt">
                                        防封禁、防羊毛党机制、黑名单管理等
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt163">
                <div class="dom-item">
                    <div class="dom-title">数字化营销的痛点</div>
                    <div class="dom-content flex mt60">
                        <div class="p-item-wrap right">
                            <div class="p-item">
                                <div class="p-item-title">活动玩法少</div>
                                <div class="p-item-desc">
                                    营销策划过程中可选择模板太少，活动形式单一，无法吸引用户参与活动。
                                </div>
                            </div>
                            <div class="p-item">
                                <div class="p-item-title">开发周期长</div>
                                <div class="p-item-desc">
                                    传统的营销周期较长，可能需1-2个月，不能快速响应业务需求。
                                </div>
                            </div>
                            <div class="p-item">
                                <div class="p-item-title">客户流失多</div>
                                <div class="p-item-desc">
                                    客户领完礼品就走，无法可持续深耕营销，无流量聚集。
                                </div>
                            </div>
                        </div>
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/img1.png"
                            alt=""
                        />
                        <div class="p-item-wrap left">
                            <div class="p-item">
                                <div class="p-item-title">营销成本高</div>
                                <div class="p-item-desc">
                                    新客获取难，广告投放成本越来越高
                                    广告渠道质量差。
                                </div>
                            </div>
                            <div class="p-item">
                                <div class="p-item-title">业绩上不去</div>
                                <div class="p-item-desc">
                                    营销方式过时，无法精准营销，跟踪不及时，业绩下降。
                                </div>
                            </div>
                            <div class="p-item">
                                <div class="p-item-title">转化率低下</div>
                                <div class="p-item-desc">
                                    广告创意太少，客户匹配度低，用户体验差，造成转化率低。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-1">
                <div class="dom-item">
                    <div class="dom-title">我们的解决方案</div>
                    <div class="boxes">
                        <div class="box">
                            <div class="num-info">
                                <span class="num">01</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">减少流量成本</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">02</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">多种活动形式</div>
                            <div class="txt">促进业务转化</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">03</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">丰富强大的</div>
                            <div class="txt">营销插件</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">04</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">大数据精准营销</div>
                            <div class="txt">客群分层</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">05</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">持续互动</div>
                            <div class="txt">增加用户粘性</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-2">
                <div class="dom-item">
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/img2.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro-title">获取流量</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >抽奖+游戏化+社交模式，让活动更具吸引力和趣味性，用户参与门槛低</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >利用社交力量裂变传播，流量成本减少50%以上</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >强大的涨粉功能，通过活动引流，吸引用户关注公众号</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt flex-reverse">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/img3.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro-title">促活留存</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >内设参与、召回机制，真正做到增强用户粘性</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >设置每日奖励，让用户养成再次访问活动的习惯</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >持续更新节日、热点活动，随时随地做活动</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/img4.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro-title">多种形式转化业务</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >多种活动形式和促销工具助您提成业务转化，达标抽奖、养成游戏、任务系统、集卡、砍价、拼团……</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >支持好友助力，传播度和影响力倍数级增强，订单成交翻倍如此简单</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >内容营销整合，借助创意营销和利益驱动等手段，实现业务增⻓</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt flex-reverse">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/img5.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro-title">精准营销</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >通过数据确定运营重点，建立特定客群体系，多渠道引流上线</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >线上统一营销，随时调整营销策略和营销预算</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >大数据分析客群特点，给不同客户推送不同产品，大大提高营销成功率</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/img6.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro-title">支持行内系统深度打通</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >支持定制化业务指标对接</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >支持多渠道用户登录打通</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >支持三方权益商城打通</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >支持产品交易打通，实现闭环经营</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt flex-reverse">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/hdcrm/img7.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro-title">快速开发与迭代</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">
                                            标准模板组件化，可复用性强</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >支持API二次开发</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >大量精美银行业务相关H5页面、海报以及标准化营销活动，覆盖各类营销场景，30分钟创建活动即可使用</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap">
                <div class="dom-item">
                    <div class="dom-title">优秀案例</div>
                    <div class="tab">
                        <div class="tab-h">
                            <div
                                :class="item.active_no ? 'on' : ''"
                                v-for="(item, index) in tabs"
                                :key="index"
                                @click="activeTabs(index)"
                            >
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="tab-b">
                            <div class="pre" @click="swipw_prev"></div>
                            <van-swipe
                                class="my-swipe"
                                @change="onChange"
                                indicator-color="white"
                                ref="mySwiper"
                            >
                                <van-swipe-item>
                                    <div class="tab-content hd-tab-content1">
                                        <div class="tab-content-info">
                                            <div class="tab-content-info-title">
                                                建信金科生态合作-建行全链路营销
                                            </div>
                                            <div class="tab-content-info-desc">
                                                自2019年起，通过主会场+分会场+子活动模式，推出近千个营销活动。活动总用户量达到千万级别，累计pv上亿，累计UV千万，业务转化量达到全行客群平均水平十倍以上。
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                                <van-swipe-item>
                                    <div
                                        class="tab-content hd-tab-content2"
                                    ></div>
                                </van-swipe-item>
                                <van-swipe-item>
                                    <div
                                        class="tab-content hd-tab-content3"
                                    ></div>
                                </van-swipe-item>
                            </van-swipe>
                            <div class="next" @click="swipw_next"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <more :moreid="id"></more>
            <info></info>
        </div>
    </div>
</template>

<script>
import header1 from "../../components/header1.vue";
import more from "../../components/more.vue";
import info from "../../components/info.vue";
export default {
    data() {
        return {
            tabs: [
                { name: "中国建设银行", active_no: true },
                { name: "厦门银行", active_no: false },
                { name: "郑州银行", active_no: false },
            ],
            id: 1
        };
    },
    components: { header1, more, info },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    computed: {},
    methods: {
        nolond() {},
        swipw_prev() {
            this.$refs.mySwiper.prev();
        },
        swipw_next() {
            console.log(this.$refs.mySwiper);
            this.$refs.mySwiper.next();
        },
        onChange(index){
            var tab = this.tabs;
            tab.forEach((item, val) => {
                if (index == val) {
                    item.active_no = true;
                } else {
                    item.active_no = false;
                }
            });
        },
        activeTabs(index) {
            var tab = this.tabs;
            tab.forEach((item, val) => {
                if (index == val) {
                    item.active_no = true;
                } else {
                    item.active_no = false;
                }
            });
            this.$refs.mySwiper.swipeTo(index);
        },
         denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
    @import "../../../static/chunk-hdcrm.css";

</style>


// WEBPACK FOOTER //
// src/views/slg/hdcrm.vue